import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'
import FancyToggle from '../elements/FancyToggle'
import { NETWORK_TELSTRA } from '../constants'

const options = {
    postUrl: '/api/postChangeRoaming',
    success: 'Success! Your global roaming details have been updated.'
}

const state = {
    serviceId: '',
    dataActive: false,
    voiceActive: false
}

class GlobalRoamingForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    isTelstra () {
        return this.props.serviceDetails && this.props.serviceDetails.networkProvider === NETWORK_TELSTRA
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRowReadOnly label='My mobile number' value={this.props.mobile} />
                <FancyToggle
                    title='Global Roaming Data'
                    name='dataActive'
                    value={this.props.values.dataActive}
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                    titleYes='On'
                    titleNo='Off'
                />

                <FancyToggle
                    title='Global Roaming Voice'
                    name='voiceActive'
                    value={this.props.values.voiceActive}
                    errors={this.props.errors}
                    handleChange={this.props.setDynamicValues}
                    titleYes='On'
                    titleNo='Off'
                />

                {this.props.children}

                <div className='mt-4 d-flex align-items-center flex-column flex-md-row'>
                    <div className='mr-4 flex-shrink-0'>
                        <Button title='Update Settings' action={this.props.handleSubmit} className={`${(this.props.fields.isPendingRequest || this.props.fields.isFailedRequest) ? 'disabled' : ''}`} />
                    </div>
                    <div>
                        <small>
                            IMPORTANT: When you activate your mobile device overseas, much higher charges may apply. Your usage alerts may also be delayed.
                        </small>
                    </div>
                </div>
                {this.props.fields.isFailedRequest && <div className='mt-3 row-error'>
                    <p className='m-0 font-small'>Global roaming updated failed. Please try again or call us on <a href='tel:133938' className='color-lime'>13 39 38</a>.</p>
                </div>}
            </form>
        )
    }
}

export default FormHOC(GlobalRoamingForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/GlobalRoamingForm.js